<template>
  <Form
    ref="loginFrom"
    :model="loginForm"
    status-icon
    :rules="formValidate"
    class="form"
    @keyup.enter.native="submitForm"
  >
    <FormItem prop="loginName">
      <Input
        v-model="loginForm.loginName"
        placeholder="手机号"
        class="fromItem"
        size="large"
      />
    </FormItem>
    <FormItem prop="password" style="margin-bottom:15px">
      <Input
        v-model="loginForm.password"
        type="password"
        password
        placeholder="密码"
        class="fromItem"
        size="large"
      />
    </FormItem>
    <FormItem style="margin-bottom:5px">
      <div class="rememberStyle">
        <div><Checkbox v-model="isRemember" />记住密码</div>
        <div class="forgetPassword" @click="toForget">
          忘记密码?
        </div>
      </div>
    </FormItem>
    <FormItem class="button">
      <Button type="primary" @click="submitForm" class="fromItem" size="large"
        >登 录</Button
      >
    </FormItem>
    <!-- <Divider> -->
    <!-- <div class="socialLoginContext">
      <span class="context">
        <i class="icon-mpai-weixin socialLogin"></i>
        <div class="socialLoginTitle">微信登录</div>
      </span>
    </div> -->
    <!-- </Divider> -->
  </Form>
</template>
<script>
export default {
  data() {
    // 校验邮箱或手机
    // let patterPhone = /^1[0-9]{10}$/;
    // let patterEmail = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;

    const validatePhone = (rule, value, callback) => {
      // if (patterPhone.test(value) || patterEmail.test(value)) {
      if (value !== null && value !== "") {
        callback();
      } else {
        callback(new Error("请输入正确的手机号码或邮箱"));
      }
    };
    //校验密码
    let patterPass = /^\S{6,}$/;
    const validatePass = (rule, value, callback) => {
      if (!patterPass.test(value)) {
        callback(new Error("请输入6位以上的密码"));
      } else {
        callback();
      }
    };
    // 页面的初始数据
    return {
      loginForm: {
        loginName: "",
        password: ""
      },
      formValidate: {
        loginName: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      visible: true,
      valids: false
    };
  },
  mounted() {
    if (this.isRemember) {
      this.loginForm = this.remember;
    }
  },
  watch: {
    loginForm: {
      handler(val) {
        if (this.isRemember) {
          this.remember = val;
        }
      },
      deep: true
    },
    isRemember(val) {
      if (val) {
        this.remember = this.loginForm;
      } else {
        this.remember = {};
      }
    }
  },
  computed: {
    remember: {
      get() {
        return this.$store.state.remember;
      },
      set(remember) {
        this.$store.dispatch("commitRemember", remember);
      }
    },
    isRemember: {
      get() {
        return this.$store.state.isRemember;
      },
      set(isRemember) {
        this.$store.dispatch("commitIsRemember", isRemember);
      }
    }
  },
  methods: {
    toForget() {
      this.$router.push({
        path: "/forgetPassword"
      });
      this.$store.dispatch("commitIsShow", false);
    },
    handleSubmit() {
      this.valids = false;
      this.$refs["loginFrom"].validate(valid => {
        this.valids = valid;
        return valid;
      });
      return this.valids;
    },
    submitForm() {
      if (this.handleSubmit()) {
        this.postUserLoginApi(this.loginForm);
      }
    },
    postUserLoginApi(data) {
      this.$axios.postUserLogin(data).then(res => {
        this.$Message.success(res.data.data);
        this.getUserMessageApi();
      });
    },
    getUserMessageApi() {
      this.$axios.getUserMessage().then(res => {
        this.$store.dispatch("commitUserMsg", res.data.data);
        this.$store.dispatch("commitIsShow", false);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromItem {
  margin: 6px 0;
  width: 100%;
}
.button {
  text-align: center;
  margin-top: 20px;
}
.form {
  margin-top: 20px;
  position: relative;
}

.title {
  color: #fff;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  height: 80px;
  line-height: 80px;
}
.rememberStyle {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0px;
  padding-left: 3px;
}
.rememberStyle:hover {
  color: #2d8cf0;
}
.forgetPassword {
  float: right;
  color: #c0c4cc;
  cursor: pointer;
}
.forgetPassword:hover {
  color: #2d8cf0;
}
.toResit {
  color: #9ca1aa;
}

.socialLogin {
  font-size: 25px;
}
.socialLoginTitle {
  font-size: 6px;
}

.socialLoginContext {
  width: 100%;
  text-align: center;
}
.context:hover {
  color: #01bc0d;
}
.context {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  color: #9ca1aa;
}
.wechart {
  width: 40px;
}
</style>
